import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { marked } from 'marked';
import { postSlugs, postPath } from '../data/postList';
import { parseFrontMatter, splitExcerpt } from '../lib/frontMatter';
import '../styles/PageTemplate.css';
import '../styles/Blog.css';

export const formatDate = (d) => {
  const t = new Date(String(d).replace(/-/g, '/'));
  return isNaN(t) ? String(d) : t.toLocaleDateString('en-GB', {
    year: 'numeric', month: 'long', day: 'numeric',
  });
};

// Hexo 扫 source/_posts 目录；浏览器不能列目录，所以按清单逐个取回 .md
// 再读它的 front-matter。文章少，一次全取没问题。
export function usePosts() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    let alive = true;
    Promise.all(postSlugs.map(slug =>
      fetch(postPath(slug))
        .then(r => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
        .then(text => {
          const { data, content } = parseFrontMatter(text);
          const { excerpt, body } = splitExcerpt(content);
          return { slug, ...data, excerpt: data.excerpt || excerpt, body };
        })
        .catch(() => null)   // 某篇取不到就跳过，不整页崩掉
    )).then(list => {
      if (!alive) return;
      setPosts(list.filter(Boolean).sort((a, b) => new Date(b.date) - new Date(a.date)));
    });
    return () => { alive = false; };
  }, []);

  return posts;
}

function Blog() {
  const posts = usePosts();

  return (
    <div className="page-container blog-page">
      <section className="page-header">
        <h1>Blog</h1>
        <p className="page-subtitle">&nbsp;</p>
      </section>

      <section className="page-content">
        {posts === null ? (
          <p className="post-empty">Loading…</p>
        ) : posts.length === 0 ? (
          <p className="post-empty">(Nothing here yet)</p>
        ) : (
          <div className="post-list">
            {posts.map(post => (
              <article className="post-card" key={post.slug}>
                <h2 className="post-card-title">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>
                <p className="post-meta">
                  <time>{formatDate(post.date)}</time>
                  {post.tags?.length > 0 && (
                    <>
                      <span className="post-meta-sep">·</span>
                      {post.tags.map(tag => <span className="post-tag" key={tag}>{tag}</span>)}
                    </>
                  )}
                </p>
                <div
                  className="post-excerpt"
                  dangerouslySetInnerHTML={{ __html: marked.parse(post.excerpt || '') }}
                />
                <Link className="post-more" to={`/blog/${post.slug}`}>Read more →</Link>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default Blog;
